export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14959.4ce3047a.jpg";